// extracted by mini-css-extract-plugin
module.exports = {"Modal":"style_Modal__mBW44"};